import "./ApplianceRepairAtlanta.module.css";
import Header from "@/reusable_sections/Header";
import Process from "./sections/Process";
import Booking from "./sections/Booking";
import Faq from "./sections/Faq";
import Appliancerepairhero from "./sections/Appliancerepairhero";
import Whychoosehandyheroes from "./sections/Whychoosehandyheroes";
import Appliancerepairgrid from "./sections/Appliancerepairgrid";
import ServiceArea from "./sections/ServiceArea";
import Footer from "@/reusable_sections/Footer";
import Bookingform from "./sections/Bookingform";
export default function ApplianceRepairAtlantaPage() {
  return <div>
      <Header />
      <Appliancerepairhero />
      <Process />
      <Bookingform />
      <Appliancerepairgrid />
      <Booking />
      <Whychoosehandyheroes />
      <ServiceArea />
      <Faq />
      <Footer />
    </div>;
}